import React from "react";
import set from "@rill/set";
import SettingsNav from "../../../parts/settings-nav";

function View(props, { locals }) {
  return (
    <main className="settings">
      <SettingsNav />

      <div className="Content">SETTINGS LANDING PAGE</div>
    </main>
  );
}

const Settings = (app) => {
  app.get("/", set("heading", "Settings"), ({ res }) => (res.body = <View />));
};

export default Settings;
